window.addEventListener('load', function() {
  const collectionList = document.querySelector('.animated-collection-list');
  if (collectionList) {
    
    // ===== ANIMATION OBSERVER =====
    // This observer handles adding/removing the 'image-visible' class based on scroll position
    let animationOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.95  // Only trigger when element is 95% visible
    };
    
    let animationObserver = new IntersectionObserver(makeVisible, animationOptions);
    collectionList.querySelectorAll('li').forEach(collection => {
      animationObserver.observe(collection);
    });
    
    function makeVisible(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('image-visible');
        } else {
          entry.target.classList.remove('image-visible');
        }
      });
    }
    
    // ===== LAZY LOADING OBSERVER =====
    // This observer preloads images before they're needed to prevent layout shifts
    let lazyLoadOptions = {
      root: null,
      rootMargin: '200px 0px',  // Start loading 200px before the element enters viewport
      threshold: 0.1            // Trigger when just 10% of the element is visible
    };
    
    let lazyLoadObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const item = entry.target;
          const slideId = item.id;  // Get the slide ID (e.g., "Slide-section-id-1")
          
          
          // Handle desktop and mobile differently
          if (window.innerWidth >= 990) {
            // DESKTOP: Preload hover images
            preloadCssBackgroundImage(slideId, ':hover');
          } else {
            // MOBILE: Preload images that appear with the 'image-visible' class
            preloadCssBackgroundImage(slideId, '.image-visible');
          }
          
          // Stop observing once we've triggered the preload
          observer.unobserve(item);
        }
      });
    }, lazyLoadOptions);
    
    // Helper function to find and preload CSS background images
    function preloadCssBackgroundImage(elementId, selector) {
      
      // Get the specific section element to target only relevant styles
      const sectionElement = document.querySelector('.animated-collection-list-wrapper');
      if (!sectionElement) return;
      
      // Get the section ID from the class that contains "section-"
      const sectionClasses = Array.from(sectionElement.classList);
      const sectionIdClass = sectionClasses.find(cls => cls.startsWith('section-'));
      
      // Extract direct background URL from inline styles in the head
      const styleElements = document.querySelectorAll('style');
      let imageFound = false;
      
      for (let styleEl of styleElements) {
        const styleContent = styleEl.textContent;
        
        // Look specifically for the rule that includes our element ID and selector
        const pattern = new RegExp(`#${elementId}\\s*${selector.replace('.', '\\.')}[^{]*{[^}]*background-image:\\s*url\\(['"]?([^'")]+)`, 'i');
        const match = styleContent.match(pattern);
        
        if (match && match[1]) {
          const imageUrl = match[1];
          
          // Actually preload the image
          const img = new Image();
          img.src = imageUrl;
          imageFound = true;
          
          img.onload = () => console.log('✨ LAZY LOAD: Image loaded for', elementId);
          img.onerror = () => console.error('❗ LAZY LOAD: Failed to load', elementId);
          
          break; // Stop once we find the first matching image
        }
      }
      
      if (!imageFound) {
        console.warn('⚠️ LAZY LOAD: No image found for', elementId);
      }
    }
    
    // Start observing all collection items for lazy loading
    collectionList.querySelectorAll('li').forEach(collection => {
      lazyLoadObserver.observe(collection);
    });
    
  }
});